import Failure from "./Failure";
import Success from "./Success";
import { Outcome } from "../helpers";

interface Props {
  outcome: Outcome;
  providerName: string;
  onClose: () => void;
}

export default function TestResult(props: Props) {
  const { outcome, providerName, onClose } = props;

  if (outcome.ok) return <Success outcome={outcome} onClose={onClose} />;

  return (
    <Failure outcome={outcome} providerName={providerName} onClose={onClose} />
  );
}
